import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  DEVELOPERS,
  API_KEYS,
  WEBHOOKS,
  INTEGRATIONS,
  FRAME_WEB,
  FRAME_WEB_SUBSCRIPTION,
  MAGNIFINANCE,
  FAQS,
  FAQS_FORM,
  EMAIL,
  ROLES,
  ROLES_TYPES,
  ROLE_FORM,
  ROLE_DETAIL,
  STRIPE,
  REDSYS,
  ASWIN,
  ASWIN_GENERIC,
  ASWIN_TEXT,
  HUBSPOT,
  CLIENTIFY,
  QUITER,
  QUITER_W,
  QUITER_API,
  AELIS,
  SII,
  LODGING,
  KEYLOOP,
  MERLOS,
  WALCU,
  AUTOLINE,
  HOLDED,
  CONTASOL,
  ODOO,
} from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Configuration",
    // redirect: { name: 'Developers' },
    redirect: { name: "Integrations" },
    component: () => import("@/modules/Configuration/Configuration"),
    meta: {
      notAllowed: ["EMPLOYEE", "USER", "SUPPORT", "EXTERNAL_SUPPORT"],
    },
    children: [
      // developers
      {
        path: DEVELOPERS,
        name: "Developers",
        component: () =>
          import("@/modules/Configuration/Pages/Developers/Developers"),
        meta: {
          code: MODULE.CONFIGURATION.DEVELOPERS,
        },
      },
      {
        path: API_KEYS,
        name: "ApiKeys",
        component: () =>
          import("@/modules/Configuration/Pages/Developers/ApiKeys"),
        meta: {
          code: MODULE.CONFIGURATION.DEVELOPERS,
        },
      },
      {
        path: WEBHOOKS,
        name: "Webhooks",
        component: () =>
          import("@/modules/Configuration/Pages/Developers/Webhooks"),
        meta: {
          code: MODULE.CONFIGURATION.DEVELOPERS,
        },
      },
      {
        path: `${WEBHOOKS}/:id`,
        name: "WebhookDetail",
        redirect: { name: "WebhookDetailLogs" },
        component: () =>
          import("@/modules/Configuration/Pages/Developers/WebhookDetail"),
        meta: {
          code: MODULE.CONFIGURATION.DEVELOPERS,
        },
        children: [
          {
            path: "logs",
            name: "WebhookDetailLogs",
            component: () =>
              import(
                "@/modules/Configuration/Pages/Developers/WebhookRegisterLogs"
              ),
            meta: {
              code: MODULE.CONFIGURATION.DEVELOPERS,
            },
          },
          {
            path: "graph",
            name: "WebhookDetailSendingsGraph",
            component: () =>
              import(
                "@/modules/Configuration/Pages/Developers/WebhookSendingsGraph"
              ),
            meta: {
              code: MODULE.CONFIGURATION.DEVELOPERS,
            },
          },
        ],
      },
      // ROLES
      {
        path: ROLES_TYPES,
        name: "RolesTypes",
        component: () =>
          import("@/modules/Configuration/Pages/Roles/RolesTypes"),
        meta: {
          code: MODULE.CONFIGURATION.ROLES_PERMISSIONS,
        },
      },
      {
        path: ROLES,
        name: "RolesList",
        component: () => import("@/modules/Configuration/Pages/Roles/RoleList"),
        meta: {
          code: MODULE.CONFIGURATION.ROLES_PERMISSIONS,
        },
      },
      {
        path: ROLE_FORM,
        name: "RoleForm",
        component: () =>
          import("@/modules/Configuration/Pages/Roles/RoleFormDetail"),
        meta: {
          code: MODULE.CONFIGURATION.ROLES_PERMISSIONS,
        },
      },
      {
        path: `${ROLE_DETAIL}/:roleId`,
        name: "RoleDetail",
        component: () =>
          import("@/modules/Configuration/Pages/Roles/RoleFormDetail"),
        meta: {
          code: MODULE.CONFIGURATION.ROLES_PERMISSIONS,
        },
      },
      // INTEGRATIONS
      {
        path: INTEGRATIONS,
        name: "Integrations",
        component: () => import("@/modules/Configuration/Pages/Integrations"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: FRAME_WEB,
        name: "FrameWeb",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/FrameWeb"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: FRAME_WEB_SUBSCRIPTION,
        name: "FrameWebSubscription",
        component: () =>
          import(
            "@/modules/Configuration/Pages/Integrations/FrameWebSubscription"
          ),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: MAGNIFINANCE,
        name: "Magnifinance",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Magnifinance"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: STRIPE,
        name: "Stripe",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Stripe"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: REDSYS,
        name: "Redsys",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Redsys"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: ASWIN,
        name: "Aswin",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Aswin"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: ASWIN_TEXT,
        name: "AswinText",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/AswinText"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: ASWIN_GENERIC,
        name: "AswinGeneric",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/AswinGeneric"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: HUBSPOT,
        name: "Hubstpot",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Hubspot"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: CLIENTIFY,
        name: "Clientify",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Clientify"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: QUITER,
        name: "Quiter",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Quiter"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: QUITER_W,
        name: "QuiterW",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/QuiterW"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: QUITER_API,
        name: "QuiterApi",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/QuiterApi"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: AELIS,
        name: "Aelis",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Aelis"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: SII,
        name: "SII",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/SII"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: LODGING,
        name: "LodgingAndVehicleRental",
        component: () =>
          import(
            "@/modules/Configuration/Pages/Integrations/LodgingAndVehicleRental"
          ),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: KEYLOOP,
        name: "Keyloop",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Keyloop"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: MERLOS,
        name: "Merlos",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Merlos"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: WALCU,
        name: "Walcu",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Walcu"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: AUTOLINE,
        name: "Autoline",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Autoline"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: HOLDED,
        name: "Holded",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Holded"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: CONTASOL,
        name: "Contasol",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Contasol"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      {
        path: ODOO,
        name: "Odoo",
        component: () =>
          import("@/modules/Configuration/Pages/Integrations/Odoo"),
        meta: {
          code: MODULE.CONFIGURATION.INTEGRATIONS,
        },
      },
      // FAQS
      {
        path: "faqs",
        name: "Faqs",
        component: () => import("@/modules/Configuration/Pages/Faqs/Index"),
        meta: {
          code: MODULE.CONFIGURATION.FAQS,
        },
      },
      {
        path: "faqs/form",
        name: "Faqs Form",
        component: () => import("@/modules/Configuration/Pages/Faqs/FaqsForm"),
        meta: {
          breadcrumb: [
            { name: "common.faqs", link: FAQS },
            { name: "common.newFaq", link: FAQS_FORM },
          ],
          code: MODULE.CONFIGURATION.FAQS,
        },
      },
      {
        path: "faqs/detail/:id",
        name: "Faqs detail",
        component: () =>
          import("@/modules/Configuration/Pages/Faqs/FaqsDetails"),
        meta: {
          code: MODULE.CONFIGURATION.FAQS,
        },
      },
      // LEGAL
      {
        path: "legal",
        name: "legal",
        component: () => import("@/modules/Configuration/Pages/Legal/Index"),
        meta: {
          code: MODULE.CONFIGURATION.LEGAL,
        },
        redirect: { name: "Terms" },
        children: [
          {
            path: "terms",
            name: "Terms",
            component: () =>
              import("@/modules/Configuration/Pages/Legal/TermsAndConditions"),
            meta: {
              code: MODULE.CONFIGURATION.LEGAL,
            },
          },
          {
            path: "policy",
            name: "Policy",
            component: () =>
              import("@/modules/Configuration/Pages/Legal/PrivacyPolicy"),
            meta: {
              code: MODULE.CONFIGURATION.LEGAL,
            },
          },
        ],
      },
      // PAYMENT_METHODS
      {
        path: "paymentMethods",
        name: "paymentMethods",
        component: () =>
          import("@/modules/Configuration/Pages/PaymentMethods/Index"),
        meta: {
          code: MODULE.CONFIGURATION.PAYMENT_METHODS,
        },
        // redirect: { name: "general" },
        // children: [
        //   {
        //     path: "general",
        //     name: "general",
        //     component: () =>
        //       import("@/modules/Configuration/Pages/PaymentMethods/General"),
        //     meta: {
        //       code: MODULE.CONFIGURATION.PAYMENT_METHODS,
        //     },
        //   },
        //   {
        //     path: "byBranch",
        //     name: "byBranch",
        //     component: () =>
        //       import("@/modules/Configuration/Pages/PaymentMethods/ByBranch"),
        //     meta: {
        //       code: MODULE.CONFIGURATION.PAYMENT_METHODS,
        //     },
        //   },
        // ],
      },
      // EMAIL
      {
        path: EMAIL,
        name: "Email",
        component: () => import("@/modules/Configuration/Pages/Email"),
        meta: {
          code: MODULE.CONFIGURATION.EMAIL,
        },
      },
      //TAGS
      {
        path: "tags",
        name: "Tags",
        component: () => import("@/modules/Configuration/Pages/Tags/Tags"),
        meta: {
          code: MODULE.CONFIGURATION.TAGS,
        },
      },
      //BUDGETS TERMS AND CONDITIONS
      {
        path: "budgets",
        name: "Budgets",
        component: () =>
          import(
            "@/modules/Configuration/Pages/Budgets/BudgetsTermsAndConditions"
          ),
        meta: {
          code: MODULE.CONFIGURATION.BUDGETS,
        },
      },
      //invoice issuers
      {
        path: "billing",
        name: "InvoiceIssuers",
        component: () =>
          import("@/modules/Configuration/Pages/Billing/InvoiceIssuer"),
        meta: {
          code: MODULE.CONFIGURATION.BILLING,
        },
      },
    ],
  },
];
